import { h } from 'preact';

export function TypingIndicator() {
  return (
    <span class="typing-indicator">
      <span class="typing-dot" />
      <span class="typing-dot" />
      <span class="typing-dot" />
    </span>
  );
}
